export default {
  id: "timeSeriesRevenueVsGrossProfit",
  name: "",
  description: "",
  report: {
    name: "Daily Revenue VS Gross Profit",
    chartType: "COLUMN",
    template: "custom",
    config: {
      dataType: "time_series",
      dataSet: "SaleItem",
      dimensions: [],
      measures: ["SaleItem.gross_profit", "SaleItem.revenue"],
      sort: {
        direction: null,
        by: null,
      },
      timeDimension: "Sale.sale_time",
      filters: [],
      compare: true,
      limit: "100",
      rowTotals: false,
      stacked: true,
      points: false,
      colorTheme: "default",
    },
  },
};
